// PageFooter override for RBC
// The footer (FooterComponent) is now rendered at the app level in Layout.tsx
// to prevent re-mounting on every page navigation.
export const PageFooter = () => {
  return null;
};
